import initSite from "./scripts/site.js"

initSite()
